import { render, staticRenderFns } from "./FooterSimpel.vue?vue&type=template&id=28f33ec0&"
import script from "./FooterSimpel.vue?vue&type=script&lang=js&"
export * from "./FooterSimpel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports